import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Bolt0_list$Bolt0 from "./bolt0_list.bs.js";
import * as Caml_js_exceptions from "bs-platform/lib/es6/caml_js_exceptions.js";

function error(param) {
  if (param[0] >= 106380200) {
    return Caml_option.some(param[1]);
  }
}

function try_with(f) {
  try {
    return (
      /* `Ok */
      [17724, Curry._1(f,
      /* () */
      0)]
    );
  } catch (raw_exn) {
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    return (
      /* `Error */
      [106380200, exn]
    );
  }
}

function $$return(x) {
  return (
    /* `Ok */
    [17724, x]
  );
}

function map(t, f) {
  if (t[0] >= 106380200) {
    return (
      /* `Error */
      [106380200, t[1]]
    );
  } else {
    return (
      /* `Ok */
      [17724, Curry._1(f, t[1])]
    );
  }
}

function map_error(t, f) {
  if (t[0] >= 106380200) {
    return (
      /* `Error */
      [106380200, Curry._1(f, t[1])]
    );
  } else {
    return (
      /* `Ok */
      [17724, t[1]]
    );
  }
}

function bind(t, f) {
  if (t[0] >= 106380200) {
    return (
      /* `Error */
      [106380200, t[1]]
    );
  } else {
    return Curry._1(f, t[1]);
  }
}

function join(tt) {
  if (tt[0] >= 106380200) {
    return (
      /* `Error */
      [106380200, tt[1]]
    );
  } else {
    return tt[1];
  }
}

function combine(t1, t2, ok, err) {
  if (t1[0] >= 106380200) {
    var e1 = t1[1];

    if (t2[0] >= 106380200) {
      return (
        /* `Error */
        [106380200, Curry._2(err, e1, t2[1])]
      );
    } else {
      return (
        /* `Error */
        [106380200, e1]
      );
    }
  } else if (t2[0] >= 106380200) {
    return (
      /* `Error */
      [106380200, t2[1]]
    );
  } else {
    return (
      /* `Ok */
      [17724, Curry._2(ok, t1[1], t2[1])]
    );
  }
}

function combine_errors(l) {
  var match = Bolt0_list$Bolt0.fold_left(function (param, x) {
    var errs = param[1];
    var oks = param[0];

    if (x[0] >= 106380200) {
      return (
        /* tuple */
        [oks,
        /* :: */
        [x[1], errs]]
      );
    } else {
      return (
        /* tuple */
        [
        /* :: */
        [x[1], oks], errs]
      );
    }
  },
  /* tuple */
  [
  /* [] */
  0,
  /* [] */
  0], l);
  var errs = match[1];

  if (errs) {
    return (
      /* `Error */
      [106380200, Bolt0_list$Bolt0.rev(errs)]
    );
  } else {
    return (
      /* `Ok */
      [17724, Bolt0_list$Bolt0.rev(match[0])]
    );
  }
}

function value_exn(param) {
  if (param[0] >= 106380200) {
    return Pervasives.failwith("Res.value_exn: expected `Ok");
  } else {
    return param[1];
  }
}

function all(l) {
  return Bolt0_list$Bolt0.fold_right(function (x, acc) {
    return combine(acc, x, function (acc, x) {
      return (
        /* :: */
        [x, acc]
      );
    }, function (x, param) {
      return x;
    });
  }, l,
  /* `Ok */
  [17724,
  /* [] */
  0]);
}

var $great$great$pipe = map;
var $great$great$eq = bind;
var Monad_infix = {
  $great$great$pipe: $great$great$pipe,
  $great$great$eq: $great$great$eq
};
export { error, try_with, $$return, map, map_error, bind, join, combine, combine_errors, value_exn, all, Monad_infix };
/* No side effect */